import React, {Component} from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect, useLocation } from "react-router-dom";

// Pages: the auth screens stay here; every dashboard page now belongs to the core pack or to the pack of the
// account's category (see packs/index.js).
import SignIn from './pages/Sign-In/Sign-In.js';
import Join from './pages/Join/Join.js';
import AuthLayout from './pages/Auth/AuthLayout.js';
import DashboardLayout from './pages/Dashboard/DashboardLayout.js';
import { currentCategory, currentModules } from './Helper/category';
import { activate, allRoutes, buildRoutes, onboardingFor } from './packs';

/** The dashboard pages of the signed-in account: core routes + its category pack, only the modules it has. A page of a
 *  module it does not have sends it home instead of showing an empty frame. Computed on every navigation, so it
 *  follows the account that is signed in now. */
function DashboardRoutes() {
  useLocation();
  const category = currentCategory();
  const modules = currentModules();
  activate(category);
  const routes = buildRoutes(category, modules);
  const shown = new Set(routes.map((r) => r.path));
  const hidden = allRoutes(category).map((r) => r.path).filter((p) => !shown.has(p));
  return (
    <Switch>
      {routes.map((r) => (
        <Route key={r.path} path={r.path} exact={!!r.exact} component={r.component} />
      ))}
      <Route path="/sign-in" />
      {hidden.length ? <Redirect from={hidden} to="/welcome" /> : null}
    </Switch>
  );
}

/** The sign-up wizard of the category pack; a category without one goes straight to the dashboard. */
function OnboardingPage() {
  const category = currentCategory();
  activate(category); // the wizard speaks the pack vocabulary, and nothing else has activated it yet on this page
  const Page = onboardingFor(category);
  return Page ? <Page /> : <Redirect to="/welcome" />;
}

class Connector extends Component {
  render() {
    return (
      <Router>
        <Switch >
          {/* AuthLayout wraps both auth routes instead of sitting inside each of
              them, so moving between the sign-in form and the signup form swaps
              only the panel: the headline keeps typing and the cards keep their
              state. */}
          {/* Sign-in lives at its own /login path. "/" stays a redirect onto it
              so every existing "not signed in" bounce across the dashboard
              (window.location.href = "/") and any old bookmark still lands on
              the login form -- there is one canonical login URL, not two. */}
          <Route path="/" exact>
            <Redirect to="/login" />
          </Route>
          <Route path={["/login", "/join"]} exact>
            <AuthLayout>
              <Switch>
                <Route path="/join" exact>
                  <Join />
                </Route>
                <Route path="/login" exact>
                  <SignIn />
                </Route>
              </Switch>
            </AuthLayout>
          </Route>
          <Route path="/onboarding" exact>
            <OnboardingPage />
          </Route>
          {/* Every dashboard page sits in one frame, mounted above this inner
              switch: moving between pages swaps only the content, and the rail
              keeps its open sections and its scroll position. */}
          <Route>
            <DashboardLayout>
              <DashboardRoutes />
            </DashboardLayout>
          </Route>
        </Switch>
      </Router>
    );
  }
}

export default Connector;
